import axios from 'axios';

import { authenticatedApiCall } from 'src/utils/apiCall/apiCall';
import { logError } from 'src/utils/logError';

const GENERIC_ERROR_MESSAGE = 'An error occurred while uploading your document';

export enum S3ResponseType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

interface S3ErrorResponse {
  error: string;
  type: S3ResponseType.ERROR;
}

interface S3SuccessResponse {
  type: S3ResponseType.SUCCESS;
  uploadReference: string;
}

export type S3Response = S3SuccessResponse | S3ErrorResponse;

const requestPresignedPostURL = async (mimeType: string) =>
  authenticatedApiCall({
    url: '/upload-locations',
    method: 'POST',
    data: { mimeType },
  });

export const uploadToS3 = async (mimeType: string, fileContents: File): Promise<S3Response> => {
  try {
    const resp = await requestPresignedPostURL(mimeType);
    // @ts-ignore
    const { uploadLocation, uploadReference } = resp.data;

    const s3response = await axios({
      url: uploadLocation,
      method: 'PUT',
      headers: {
        'Content-Type': mimeType,
        'x-amz-server-side-encryption': 'AES256',
        'x-amz-tagging': 'expires=true',
      },
      data: fileContents,
      validateStatus: (_) => true,
    });

    if (s3response.status === 200) {
      return {
        type: S3ResponseType.SUCCESS,
        uploadReference,
      };
    }

    logError(`S3 file upload error response ${s3response.status}`);
    return {
      type: S3ResponseType.ERROR,
      error: GENERIC_ERROR_MESSAGE,
    };
  } catch (ex) {
    logError(`S3 presigned post url negotiation error: ${(ex as Error).message}`);
    return {
      type: S3ResponseType.ERROR,
      error: GENERIC_ERROR_MESSAGE,
    };
  }
};
